import type { FaireProductEntity } from "../../entity_types/product";

export const p_ux9hgwxec2: FaireProductEntity = {
  token: "p_ux9hgwxec2",
  type: "product",
  name: "Foodservice Gallons - Zab's Original Hot Sauce",
  brandToken: "b_70objmt9p3",
  brandName: "Zab's Datil Pepper Hot Sauce",
  imageUrl:
    "https://cdn.faire.com/fastly/4918302e19a18b4b0d8ee4c4b7af3ce0dbb63934322881cbece89943f852b0d8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cba6537414c7809649728b485dd1fe3edaa8c30b6968fe25689c9a5db79d500b.jpeg",
    "https://cdn.faire.com/fastly/de2b7c6e334ebdaff13f4271c97ef792065990263b3bb758a11e4c9a0afbfa04.jpeg",
    "https://cdn.faire.com/fastly/8914a43eaef7dfa14637cfc6b901332a93230933792ef3c6e1f8c5b24afa9891.jpeg",
  ],
  priceDollars: 50,
  description:
    "For our restaurant friends!\n\nOur Datil Pepper twist on a classic vinegar-based hot sauce:  the essence of the Datil Pepper's naturally sweet heat and signature Slow Burn.  ",
  tags: [],
  msrpDollars: 80,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:56.982Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
